// extracted by mini-css-extract-plugin
export default {"mCard":"yE-z","image":"zE-z","imageNoBackground":"AE-z","imageHasCategory":"BE-z","fullWidth":"CE-z"};